import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type GetQuizSessionsOrderByOptions =
   | 'username'
   | 'quiz_title'
   | 'doc_title'
   | 'last_modified'
   | 'status';

export type GetQuizSessionStruct = {
   quiz_sessionid: number;
   userid: number;
   quizid: number;
   quiz_revisionid: number;
   docid: number;
   doc_title: string;
   doc_revisionid: number;
   doctype: string;
   doc_revision_title: string;
   response_json: number;
   init_date: number;
   end_date: number;
   score: number;
   passed: boolean;
   cancelled: boolean;
   username: string;
   email: string;
   quiz_title: string;
   status: string;
   last_modified: number;
};

export type GetQuizSessionsResponse = {
   quizSessions: GetQuizSessionStruct[];
   hasMore: boolean;
};

export type GetQuizSessionsOptions = CommonRequestOptions & {
   orderby?: GetQuizSessionsOrderByOptions;
   direction?: 'ASC' | 'DESC';
   offset?: number;
   limit?: number;
   query?: string;
   teamid?: number;
   showMyQuizzes?: boolean;
};

export async function getQuizSessions({
   orderby,
   direction,
   offset,
   limit,
   query,
   showMyQuizzes,
   teamid,
   ...common
}: GetQuizSessionsOptions = {}): Promise<GetQuizSessionsResponse> {
   return makeRequest('get', '/quizzes/sessions', {
      ...common,
      query: {
         orderby,
         direction,
         offset,
         limit,
         query,
         showMyQuizzes,
         teamid,
      },
   });
}
